import React from 'react';
import { NavLink } from 'react-router-dom';  // Use NavLink for active link styling
import './LinkMap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCalendarAlt, faUsers, faUserFriends, faBoxes, faUserDoctor, faCog, faSignOut } from '@fortawesome/free-solid-svg-icons'; // Import only the icons you're using

const LinkMap = ({ links, moduleName, moduleIcon, activeStyle }) => {
    // Map module icon to the actual FontAwesome icon
    const iconMap = {
        'calendar': faCalendarAlt,
        'users': faUsers,
        'doctor': faUserDoctor,
        'patients': faUsers,
        'inventory': faBoxes
        // Add other icons as needed
    };

    return (
        <nav>
            <ul className="linkmap-container">
                <div className="module-header">
                    {moduleIcon && (
                        <FontAwesomeIcon 
                            icon={iconMap[moduleIcon]} 
                            style={{ marginRight: '8px', fontSize: '18px' }} 
                        />
                    )}
                    {moduleName}
                </div>
                <div className="links-container">
                    {links.map((link, index) => (
                        <li key={index} style={{ marginRight: '10px' }}>
                            {/* Use NavLink to manage active link styles */}
                            <NavLink 
                                to={link.path} 
                                style={({ isActive }) => ({
                                    textDecoration: 'none',
                                    color: 'black',
                                    fontWeight: isActive ? 'bold' : 'normal',  // Bold when active
                                    ...activeStyle  // Apply additional active styles passed as prop
                                })}
                            >
                                {link.label}
                            </NavLink>
                            {index < links.length - 1 && ' / '}
                        </li>
                    ))}
                </div>
            </ul>
        </nav>
    );
};

export default LinkMap;
